import React, { useState, useRef, useEffect } from 'react';
import { Input } from '@progress/kendo-react-inputs';
const OtpInput = ({ length = 6, onComplete, onChange, value, autoFocus = false }) => {
    const [otp, setOtp] = useState(new Array(length).fill(''));
    const inputRefs = useRef([]);
    const prevValueRef = useRef(value);

    const focusBox = (index) => inputRefs.current[index]?.focus();

    useEffect(() => {
        if (autoFocus) {
            focusBox(0);
        }
    }, []);

    useEffect(() => {
        if (value) {
            const valueArray = value.toString().split('').slice(0, length);
            const newOtp = new Array(length).fill('');

            valueArray.forEach((digit, index) => {
                if (index < length && !isNaN(digit)) {
                    newOtp[index] = digit;
                }
            });

            setOtp(newOtp);

            if (newOtp.every(digit => digit !== '')) {
                onComplete && onComplete(newOtp.join(''));
            }
            onChange && onChange(newOtp.join(''));
        } else {
            setOtp(new Array(length).fill(''));
            if (autoFocus && prevValueRef.current) {
                focusBox(0);
            }
        }
        prevValueRef.current = value;
    }, [value]);

    const handleChange = (e, index) => {
        const value = e.target.value;
        if (isNaN(value) || value.length > 1) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);
        onChange && onChange(newOtp.join(''));

        if (value && index < length - 1) {
            focusBox(index + 1);
        } else if (newOtp.every(digit => digit !== '')) {
            onComplete && onComplete(newOtp.join(''));
        }
    };

    const handlePaste = (e, index) => {
        const pasted = e.clipboardData?.getData('text') ?? '';
        const digits = pasted.replace(/\D/g, '').slice(0, length - index);
        if (!digits) return;

        e.preventDefault();
        const newOtp = [...otp];
        digits.split('').forEach((digit, offset) => {
            newOtp[index + offset] = digit;
        });
        setOtp(newOtp);
        onChange && onChange(newOtp.join(''));
        focusBox(Math.min(index + digits.length, length - 1));

        if (newOtp.every(d => d !== '')) {
            onComplete && onComplete(newOtp.join(''));
        }
    };

    const handleFocus = (e) => {
        const element = e.target?.element ?? e.target;
        element?.select();
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            focusBox(index - 1);
        }
    };

    return (
        <div style={{ display: 'flex', gap: '8px' }}>
            {otp.map((digit, index) => (
                <Input
                    key={index}
                    type="text"
                    value={digit}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onFocus={handleFocus}
                    onPaste={(e) => handlePaste(e, index)}
                    maxLength={1}
                    style={{ width: '40px', textAlign: 'center' }}
                    ref={(el) => (inputRefs.current[index] = el)}
                />
            ))}
        </div>
    );
};

export default OtpInput;
